"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.virtualGamesProviderActions = exports.initialState = void 0;
const _reduxjs_1 = require("../../utils/@reduxjs");
const api_1 = require("../../utils/api");
const getInitialItemState = () => ({
    fetchItem: { ...api_1.requestInitialState },
});
exports.initialState = {};
const virtualGamesSlice = (0, _reduxjs_1.createSlice)({
    name: 'virtualGamesProvider',
    initialState: exports.initialState,
    reducers: {
        getToken(state, action) {
            const { gameVendor } = action.payload;
            if (state[gameVendor] === undefined) {
                state[gameVendor] = getInitialItemState();
            }
            state[gameVendor].fetchItem.loading = true;
        },
        getTokenSuccess(state, action) {
            const { gameVendor, token } = action.payload;
            if (state[gameVendor] === undefined) {
                state[gameVendor] = getInitialItemState();
            }
            state[gameVendor].fetchItem.loading = false;
            state[gameVendor].fetchItem.error = null;
            state[gameVendor].entry = token;
        },
        getTokenError(state, action) {
            const { gameVendor, error } = action.payload;
            if (state[gameVendor] === undefined) {
                state[gameVendor] = getInitialItemState();
            }
            state[gameVendor].fetchItem.loading = false;
            state[gameVendor].fetchItem.error = error;
        },
        resetVirtualGameState(state, action) {
            const { gameVendor } = action.payload;
            state[gameVendor] = getInitialItemState();
        },
    },
});
exports.virtualGamesProviderActions = virtualGamesSlice.actions, exports.reducer = virtualGamesSlice.reducer, exports.sliceKey = virtualGamesSlice.name;
//# sourceMappingURL=slice.js.map